import { render } from "./siteDashboard.vue?vue&type=template&id=5ef8b4b9&ts=true"
import script from "./siteDashboard.vue?vue&type=script&lang=ts"
export * from "./siteDashboard.vue?vue&type=script&lang=ts"

import "./siteDashboard.vue?vue&type=style&index=0&id=5ef8b4b9&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__